import styled from 'styled-components';

export const FlexDivWrap = styled.div`
	display: flex;
  flex-direction: row;
  gap:1rem

`;
export const ToolbarLabel = styled.div`
	color:var(--textHeadingColor);
	font-size: 1.063rem;
	font-weight: 500;
`;

export const EditToolOptionsWrap = styled.div`
	display: flex;
	align-items: center; 
	// gap: 10px;
	overflow: hidden;

`;
export const SvgIcon = styled.svg`
 	animation: zoomInOut 2s infinite ease-in-out;
  transition: transform 0.3s ease-in-out;
	&:hover {
		animation-play-state: paused;
	}
	@keyframes zoomInOut {
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
}
`;
